var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sign-in-container form-container" }, [
    _c("div", { staticClass: "center-flex-inline" }, [
      _c("p", [
        _vm._v("New here?   "),
        _c(
          "span",
          { staticClass: "link", on: { click: _vm.handleClickSignUp } },
          [_vm._v("Sign up")]
        ),
        _vm._v(" now!")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contact-form" }, [
      _c(
        "div",
        { staticClass: "contact-field", class: _vm.updatePhoneClass() },
        [
          _c("BaseIcon", {
            staticClass: "input-field-icon icon-mobile",
            attrs: { icon: "mobile", isCustom: true, size: "1x" }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone"
              }
            ],
            staticClass: "input text-input has-icon",
            class: _vm.liveValidate ? "is-success" : "is-danger",
            attrs: { type: "tel", placeholder: "Mobile Number" },
            domProps: { value: _vm.phone },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phone = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "terms-wrapper" }, [
        _c(
          "label",
          {
            ref: "leaveAtDoorCheckbox",
            staticClass: "control control--checkbox cust-radio"
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.acceptTerms,
                  expression: "acceptTerms"
                }
              ],
              attrs: {
                type: "checkbox",
                role: "checkbox",
                "aria-label": "accept terms of service"
              },
              domProps: {
                checked: Array.isArray(_vm.acceptTerms)
                  ? _vm._i(_vm.acceptTerms, null) > -1
                  : _vm.acceptTerms
              },
              on: {
                change: function($event) {
                  var $$a = _vm.acceptTerms,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.acceptTerms = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.acceptTerms = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.acceptTerms = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "control__indicator checkbox" }),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact-field" },
        [
          _c("BaseButton", {
            attrs: {
              classNames: ["button--modifier", "input-field-button"],
              title: "Sign In",
              type: "scaleable-fixed-square",
              disabled: !_vm.validPhone || !_vm.acceptTerms
            },
            on: { click: _vm.handleClickSignIn }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "small-link",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm._navigateToGuestForm($event)
            }
          }
        },
        [_vm._v("or continue as guest")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "is-size-7" }, [
      _vm._v("\n\t\t\t\t\tI agree to the "),
      _c(
        "a",
        {
          staticClass: "red-link",
          attrs: { target: "_blank", href: "https://www.touchpoint.io/terms" }
        },
        [_vm._v("Terms of Service")]
      ),
      _vm._v(". Learn about how we use and protect your data in our "),
      _c(
        "a",
        {
          staticClass: "red-link",
          attrs: { target: "_blank", href: "https://www.touchpoint.io/privacy" }
        },
        [_vm._v("Privacy Policy")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72128214", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72128214","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/SignIn.vue
// module id = null
// module chunks = 